import { render } from "./recapMomo.vue?vue&type=template&id=620f5f26&scoped=true"
import script from "./recapMomo.vue?vue&type=script&lang=js"
export * from "./recapMomo.vue?vue&type=script&lang=js"

import "./recapMomo.vue?vue&type=style&index=0&id=620f5f26&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620f5f26"]])

export default __exports__